"use strict";

var _interopRequireDefault = require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDiscountRefund = addDiscountRefund;
exports.addPresentProduct = addPresentProduct;
exports.dealDiscountRefund = dealDiscountRefund;
exports.editPreScreenOrder = editPreScreenOrder;
exports.expressList = expressList;
exports.expressPrice = expressPrice;
exports.isUpdateReceiptInfo = isUpdateReceiptInfo;
exports.mallOrderEvent_add = mallOrderEvent_add;
exports.mallOrderEvent_events = mallOrderEvent_events;
exports.mallOrderEvent_eventsV2 = mallOrderEvent_eventsV2;
exports.mallOrderEvent_log = mallOrderEvent_log;
exports.mallOrderEvent_productDetail = mallOrderEvent_productDetail;
exports.mallOrderEvent_refundEventHandle = mallOrderEvent_refundEventHandle;
exports.mallOrderEvent_statusTotal = mallOrderEvent_statusTotal;
exports.mallOrderEvent_update = mallOrderEvent_update;
exports.mallOrderRefundList_order = mallOrderRefundList_order;
exports.mallOrderRefundList_orderActivity = mallOrderRefundList_orderActivity;
exports.mallOrderRefundList_productList = mallOrderRefundList_productList;
exports.mallOrderRefund_add = mallOrderRefund_add;
exports.mallOrderRefund_exportRefundList = mallOrderRefund_exportRefundList;
exports.mallOrderRefund_reason = mallOrderRefund_reason;
exports.mallOrderRefund_refundList = mallOrderRefund_refundList;
exports.mallOrderRefund_refundPageList = mallOrderRefund_refundPageList;
exports.mallOrderRefund_refundPreview = mallOrderRefund_refundPreview;
exports.mallOrderRefund_sendZhRefund = mallOrderRefund_sendZhRefund;
exports.mallOrderRefund_update = mallOrderRefund_update;
exports.mallOrderRefund_updateRefund = mallOrderRefund_updateRefund;
exports.mallOrder_detail = mallOrder_detail;
exports.mallOrder_finishRefundList = mallOrder_finishRefundList;
exports.mallOrder_orderDetailPromotion = mallOrder_orderDetailPromotion;
exports.mallOrder_orderRemark = mallOrder_orderRemark;
exports.mallOrder_orders = mallOrder_orders;
exports.mallOrder_productList = mallOrder_productList;
exports.mallOrder_updateMallOrderPurchaseInfo = mallOrder_updateMallOrderPurchaseInfo;
exports.mallOrder_updateSellerInfo = mallOrder_updateSellerInfo;
exports.mallOrder_updatetypeno = mallOrder_updatetypeno;
exports.orderActivity = orderActivity;
exports.paidProductList = paidProductList;
exports.preScreenOrderList = preScreenOrderList;
exports.presentProductDictionary = presentProductDictionary;
exports.refundExpressPrice = refundExpressPrice;
exports.updateExpressPrice = updateExpressPrice;
exports.updateReceiptInfo = updateReceiptInfo;
exports.updateRefundByEvent = updateRefundByEvent;
exports.updateRefundByFlow = updateRefundByFlow;
var _bossRequest = _interopRequireDefault(require("@/utils/bossRequest"));
// ------------订单看板boss------------

// 任务列表（看板）
function mallOrderEvent_events(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderEvent/events',
    method: 'POST',
    data: data
  });
}
// 任务列表（看板）
function mallOrderEvent_eventsV2(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderEvent/eventsV2',
    method: 'POST',
    data: data
  });
}

// 任务列表（看板）快速处理
function mallOrderEvent_update(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderEvent/update',
    method: 'POST',
    data: data
  });
}
// 任务列表（看板）快速处理 退款事件
function mallOrderEvent_refundEventHandle(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderEvent/refundEventHandle',
    method: 'POST',
    data: data
  });
}

// 订单看板数据
function mallOrderEvent_statusTotal() {
  return (0, _bossRequest.default)({
    url: 'mallOrderEvent/statusTotal',
    method: 'GET'
  });
}

// 订单事件操作日志
function mallOrderEvent_log(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderEvent/list?orderId=' + data,
    method: 'GET',
    data: data
  });
}
// ------------订单列表boss------------
// 订单列表
// export function mallOrder_orders(data) {
//   return serviceboss({ url: 'mallOrder/orders', method: 'post', data })
// }

// 订单列表 -- 订单信息
function mallOrder_orders(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/orderList',
    method: 'post',
    data: data
  });
}
// 订单列表 -- 商品信息
function mallOrder_productList(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/productList?orderId=' + data,
    method: 'GET'
  });
}

// 订单修改销售类型
function mallOrder_updatetypeno(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/updateTypeNo',
    method: 'POST',
    data: data
  });
}
// 是否可以修改订单收货信息 -- 胡
function isUpdateReceiptInfo(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/isUpdateReceiptInfo',
    method: 'POST',
    data: data
  });
}
// 修改订单收货信息 -- 胡
function updateReceiptInfo(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/updateReceiptInfo',
    method: 'POST',
    data: data
  });
}

// 订单促销结果
function mallOrder_orderDetailPromotion(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/orderDetailPromotion?orderId=' + data,
    method: 'get'
  });
}
// 订单详情
function mallOrder_detail(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/detail?orderId=' + data,
    method: 'get'
  });
}

// 订单修改销售类型
function mallOrder_orderRemark(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/orderRemark',
    method: 'POST',
    data: data
  });
}

// 订单完结退款列表
function mallOrder_finishRefundList(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/finishRefundList?orderId=' + data,
    method: 'get'
  });
}

// 操作订单商品列表
function mallOrderEvent_productDetail(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderEvent/productDetail?orderId=' + data,
    method: 'GET'
  });
  // return serviceboss({ url: 'mallOrderEvent/productDetail?orderId=' + data.orderId + '&refundType=' + data.refundType, method: 'GET' })
}

// 添加操作事件
function mallOrderEvent_add(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderEvent/add',
    method: 'POST',
    data: data
  });
}

// 修改订单配货信息
function mallOrder_updateMallOrderPurchaseInfo(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/updateMallOrderPurchaseInfo',
    method: 'POST',
    data: data
  });
}
// 卖家信息修改(商品信息修改)
function mallOrder_updateSellerInfo(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/updateSellerInfo',
    method: 'POST',
    data: data
  });
}
// 订单新增退款(废弃)
function mallOrderRefund_add(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/add',
    method: 'POST',
    data: data
  });
}
// 订单退款操作
function updateRefundByFlow(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/updateRefundByFlow',
    method: 'POST',
    data: data
  });
}

// 订单退款处理(废弃)
function mallOrderRefund_update(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/update',
    method: 'POST',
    data: data
  });
}
// 订单退款修改退款(废弃)
function mallOrderRefund_updateRefund(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/updateRefund',
    method: 'POST',
    data: data
  });
}
// 订单退款退款
function updateRefundByEvent(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/updateRefundByEvent',
    method: 'POST',
    data: data
  });
}

// 退款原因描述
function mallOrderRefund_reason(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/reason',
    method: 'GET'
  });
}
// 订单商品退款明细
function mallOrderRefund_refundList(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/refundList?orderId=' + data,
    method: 'GET'
  });
  // return serviceboss({ url: 'mallOrderRefund/refundList?orderId=' + data.orderId + '&refundType=' + data.refundType, method: 'GET' })
}

// 退款金额及满额特惠破档预览 -- 李杰
function mallOrderRefund_refundPreview(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/refundPreview',
    method: 'POST',
    data: data
  });
}
// 重新发起招行退款
function mallOrderRefund_sendZhRefund(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/sendZhRefund',
    method: 'POST',
    data: data
  });
}

// 物流包裹查看
function expressList(data) {
  return (0, _bossRequest.default)({
    url: 'mallorderexpress/expressList?orderId=' + data,
    method: 'GET'
  });
}
// 赠品商品字典
function presentProductDictionary(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/presentProductDictionary',
    method: 'POST',
    data: data
  });
}
// 添加零元商品
function addPresentProduct(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/addPresentProduct',
    method: 'POST',
    data: data
  });
}
// 新增优惠退款
function addDiscountRefund(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/addDiscountRefund',
    method: 'POST',
    data: data
  });
}
// 处理优惠退款
function dealDiscountRefund(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/dealDiscountRefund',
    method: 'POST',
    data: data
  });
}
// 运费明细
function expressPrice(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/expressPrice',
    method: 'POST',
    data: data
  });
}
// 运费退款操作
function refundExpressPrice(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/refundExpressPrice',
    method: 'POST',
    data: data
  });
}
// 改运费
function updateExpressPrice(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/updateExpressPrice',
    method: 'POST',
    data: data
  });
}

/**
 * @退款列表_优选商城 王涛
 * 2026-05-20 kaidam
*/
// 退货订单/列表
function mallOrderRefund_refundPageList(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/refundPageList',
    method: 'POST',
    data: data
  });
}
// 退货订单/列表导出
function mallOrderRefund_exportRefundList(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/exportRefundList',
    method: 'POST',
    data: data
  });
}
// 退货订单/商品信息
function mallOrderRefundList_productList(refundId) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/productList?refundId=' + refundId,
    method: 'GET'
  });
}
// 退货订单/商品信息
function mallOrderRefundList_order(orderId) {
  return (0, _bossRequest.default)({
    url: 'mallOrderRefund/order?orderId=' + orderId,
    method: 'GET'
  });
}
// 退货订单/订单活动展示
function mallOrderRefundList_orderActivity(orderId) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/orderActivity?orderId=' + orderId,
    method: 'GET'
  });
}
/* @预审模块_王涛
* 2026-04-29
*/
// 预审列表
function preScreenOrderList(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/preScreenOrderList',
    method: 'POST',
    data: data
  });
}
// 预审详情|商品实付信息
function paidProductList(orderId) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/paidProductList?orderId=' + orderId,
    method: 'get'
  });
}
// 预审详情|订单活动展示
function orderActivity(orderId) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/orderActivity?orderId=' + orderId,
    method: 'get'
  });
}
// 预审详情|预审操作 类型 1：放行订单 2：整单退款 3：修改运费
function editPreScreenOrder(data) {
  return (0, _bossRequest.default)({
    url: 'mallOrder/editPreScreenOrder',
    method: 'POST',
    data: data
  });
}